import actionTypes from '../actions/actionTypes'

const defaultState = {
	users: [],
	redirectAfterInvite: false,
	invites: 0,
	roles: [],
	confirmSchoolError: false,
	adminOnboardingInitializeTime: 0,
	step: -1,
	isAdmin: false,
	maxVisitedStep: -1,
	transitioning: -1,
	inviteTeacher: false,
	showLastStep: false,
	redirectAfterRefer: false,
	redirectAfterCongrats: false,
	premiumActivitiesAddLessonStep: 0,
	durationDays: 0,
	isTrialFromSF: false,
}

function initializeAdminOnboarding(state, action) {
	const newState = {...state}
	if (action.params.step) {
		newState.step = parseInt(action.params.step)
	} else {
		newState.step = 1
	}
	newState.isAdmin = action.params.userRole === 'admin'

	newState.maxVisitedStep = Math.max(state.maxVisitedStep, newState.step)
	return newState
}

function changeStep(state, action) {
	const newState = {...state, ...{
		step: action.step,
		maxVisitedStep: Math.max(state.maxVisitedStep, action.step),
	},
	}
	return newState
}

function transitionStep(state) {
	return {...state, transitioning: state.step}
}

function resetTransitioning(state) {
	return {...state, transitioning: -1}
}

function usersFetched(state, action) {
	const newState = {...state}
	const users = action.payload.users.map((element, index) => ({
		...element,
		belongsToInstitution: true,
		isNew: false,
		selected: newState.isAdmin && index !== 0,
	}))
	newState.users = users
	newState.invites = action.payload.maxUsers
	return newState
}

function selectUser(state, action) {
	const newState = {...state}
	newState.users[action.index].selected = !newState.users[action.index].selected
	return newState
}

function updateUsers(state, action) {
	//make sure that user is not already added
	const userDuplicated = state.users.find(function(element) {
		return element.id === action.payload.id
	})
	if (userDuplicated) {
		return state
	}
	const newState = {...state}
	const { id, icon, firstName, lastName, email, isNew } = action.payload
	const newUser = { id, icon, firstName, lastName, email, isNew, selected: true, invited: true }
	newState.users = [...state.users, newUser]
	return newState
}

function inviteUsersRedirect(state) {
	const newState = {...state}
	newState.inviteTeacher = false
	newState.redirectAfterInvite = true
	return newState
}

function shareTeachersRedirect(state) {
	const newState = {...state}
	newState.redirectAfterInvite = true
	return newState
}

function resetInviteUsersState(state) {
	const newState = {...state}
	newState.inviteTeacher = false
	newState.redirectAfterInvite = false
	return newState
}

function addUserErrors(state, action) {
	const newState = {...state}
	newState.addUserErrors = action.errors
	return newState
}

function updateStep(state, action) {
	const newState = {...state}
	if (action.payload.roles) {
		newState.roles = action.payload.roles
	}
	newState.stepIsValid = true
	return newState
}

function updateConfirmSchoolError(state) {
	const newState = {...state}
	newState.confirmSchoolError = true
	return newState
}

function initializeConfirmSchoolView(state) {
	const newState = {...state}
	newState.confirmSchoolError = false
	newState.adminOnboardingInitializeTime = Date.now()
	return newState
}

function welcomeInviteAccepted(state) {
	const newState = {...state}
	newState.inviteTeacher = true
	return newState
}

function contactGoToLastStep(state) {
	const newState = {...state}
	newState.showLastStep = true
	return newState
}

function showEnvelopeAnimation(state) {
	const newState = {...state}
	newState.redirectAfterRefer = true
	return newState
}

function setRedirectAfterCongrats(state) {
	const newState = {...state}
	newState.redirectAfterCongrats = true
	return newState
}

function shareTeachersInitialize(state) {
	const newState = { ...state }
	newState.isAdmin = true
	return newState
}

function setPremiumActivitiesAddLessonStep(state, action) {
	const newState = { ...state }
	newState.premiumActivitiesAddLessonStep = action.step ? action.step : 0
	return newState
}

function setTrialData(state, action) {
	return {
		...state,
		durationDays: action.durationDays || 0,
		isTrialFromSF: action.isTrialFromSF,
	}
}

const adminOnboardingReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.ADMIN_ONBOARDING_INITIALIZE: {
			return initializeAdminOnboarding(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_INITIALIZE: {
			return shareTeachersInitialize(state)
		}
		case actionTypes.ADMIN_ONBOARDING_CHANGE_STEP: {
			return changeStep(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_TRANSITION_STEP: {
			return transitionStep(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_RESET_STEP_TRANSITION: {
			return resetTransitioning(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_GET_USERS_FETCHED: {
			return usersFetched(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_SELECT_USER: {
			return selectUser(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_ADD_USER_SUCCESS: {
			return updateUsers(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_COLLEAGUES_SUCCESS:
		case actionTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRMED:
			return shareTeachersRedirect(state, action)

		case actionTypes.ADMIN_ONBOARDING_INVITE_CONFIRMED:
		case actionTypes.ADMIN_ONBOARDING_INVITE_USERS:
		case actionTypes.ADMIN_ONBOARDING_JOIN_COLLEAGUES: {
			return inviteUsersRedirect(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_REFER_CONTACT_INITIALIZE: {
			return resetInviteUsersState(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_ADD_USER_FAILED: {
			return addUserErrors(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_VALIDATE_STEP_SUCCESS: {
			return updateStep(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_SCHOOL_NOT_CONFIRMED_SUCCESS: {
			return updateConfirmSchoolError(state)
		}
		case actionTypes.ADMIN_ONBOARDING_INITIALIZE_CONFIRM_SCHOOL_VIEW: {
			return initializeConfirmSchoolView(state)
		}
		case actionTypes.ADMIN_ONBOARDING_ACCEPT_WELCOME_INVITE_REDIRECT: {
			return welcomeInviteAccepted(state)
		}
		case actionTypes.ADMIN_ONBOARDING_SKIP_TO_LAST_STEP_REDIRECT:
		case actionTypes.ADMIN_ONBOARDING_REFER_A_CONTACT_SENT_SUCCESS: {
			return contactGoToLastStep(state)
		}
		case actionTypes.ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_SEND:
		case actionTypes.ADMIN_ONBOARDING_REFER_A_CONTACT_SENT: {
			return showEnvelopeAnimation(state)
		}
		case actionTypes.ADMIN_ONBOARDING_REDIRECT_AFTER_CONGRATS: {
			return setRedirectAfterCongrats(state)
		}
		case actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_ADD_LESSON:
		case actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_ADD_LESSON_COMPLETED: {
			return setPremiumActivitiesAddLessonStep(state, action)
		}
		case actionTypes.ADMIN_ONBOARDING_SCHOOL_CONFIRMED_SUCCESS:
		case actionTypes.ADMIN_ONBOARDING_GET_TRIAL_DATA_COMPLETED: {
			return setTrialData(state, action)
		}
		default:
			return state
	}
}

export default adminOnboardingReducer
